jQuery(document).ready(function ($) {
	const carouselSliderElement = jQuery(".slideshow-carousel__slides");

	//this sets the '1 of 2' etc label on the homepage slider
	carouselSliderElement.on("init reInit afterChange", function (event, slick, currentSlide, nextSlide) {
		const carouselSlider = $(this);

		const pagingInfo = carouselSlider.closest(".slideshow-carousel").find(".slideshow-carousel__paging-info");

		let i = (currentSlide ? currentSlide : 0) + 1;
		pagingInfo.text(i + " of " + slick.slideCount);
	});

	carouselSliderElement.each(function () {
		const carousel = $(this).closest(".slideshow-carousel");
		const pagination = carousel.find(".slideshow-carousel-pagination");
		$(this).slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			swipeToSlide: true,
			speed: 200,
			dots: false,
			appendArrows: pagination,
			prevArrow: '<div class="pagination__button prev"></div>',
			nextArrow: '<div class="pagination__button next"></div>',
			responsive: [
				{
					breakpoint: 768,
					settings: {
						dots: true,
					},
				},
				// You can unslick at a given breakpoint now by adding:
				// settings: "unslick"
				// instead of a settings object
			],
		});
	});
});

// Play UPLOADED video on button click
jQuery(document).ready(function () {
	jQuery(".slideshow-slide__video-wrapper.video svg").on("click", function () {
		var svg = jQuery(this);
		var wrapper = svg.parent();
		var video = wrapper.children(".slideshow-carousel__slider-video");
		wrapper.addClass("play");
		video.get(0).play();
	});
});

// Play EMBEDDED video on button click
jQuery(document).ready(function () {
	jQuery(".slideshow-slide__video-wrapper.iframe svg").on("click", function () {
		jQuery(this).closest(".slideshow-slide__video-wrapper").addClass("play");
		jQuery(this).closest(".slideshow-slide__video-wrapper").find("iframe")[0].src += "?autoplay=1";
	});
});
